const data = {
  districts: [
    {
      name: "Myagdi",
      palikas: [
        {
          name: "Beni",
          wards: [
            "Ward 1",
            "Ward 2",
            "Ward 3",
            "Ward 4",
            "Ward 5",
            "Ward 6",
            "Ward 7",
            "Ward 8",
            "Ward 9",
            "Ward 10",
          ],
        },
        {
          name: "Annapurna",
          wards: [
            "Ward 1",
            "Ward 2",
            "Ward 3",
            "Ward 4",
            "Ward 5",
            "Ward 6",
            "Ward 7",
            "Ward 8",
          ],
        },
        {
          name: "Dhaulagiri",
          wards: [
            "Ward 1",
            "Ward 2",
            "Ward 3",
            "Ward 4",
            "Ward 5",
            "Ward 6",
            "Ward 7",
          ],
        },
        {
          name: "Mangala",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
        {
          name: "Malika",
          wards: [
            "Ward 1",
            "Ward 2",
            "Ward 3",
            "Ward 4",
            "Ward 5",
            "Ward 6",
            "Ward 7",
          ],
        },
        {
          name: "Raghuganga",
          wards: [
            "Ward 1",
            "Ward 2",
            "Ward 3",
            "Ward 4",
            "Ward 5",
            "Ward 6",
            "Ward 7",
            "Ward 8",
          ],
        },
      ],
    },
    {
      name: "Mustang",
      palikas: [
        {
          name: "Gharpajhong",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
        {
          name: "Thasang",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
        {
          name: "Baragung",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
        {
          name: "Lomanthang",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
        {
          name: "LoGhekar",
          wards: ["Ward 1", "Ward 2", "Ward 3", "Ward 4", "Ward 5"],
        },
      ],
    },
    {
      name: "Baglung",
      palikas: [
        {
          name: "Palika Baglung",
          wards: ["Ward 1", "Ward 2"],
        },
      ],
    },
    {
      name: "Parbat",
      palikas: [
        {
          name: "Palika Parbat",
          wards: ["Ward 1", "Ward 2"],
        },
      ],
    },
    {
      name: "Kaski",
      palikas: [
        {
          name: "Palika Parbat",
          wards: ["Ward 1", "Ward 2"],
        },
      ],
    },
  ],
};
export default data;
